import { render, staticRenderFns } from "./AppDetailModal.vue?vue&type=template&id=5d97c85e&scoped=true"
import script from "./AppDetailModal.vue?vue&type=script&lang=js"
export * from "./AppDetailModal.vue?vue&type=script&lang=js"
import style0 from "./AppDetailModal.vue?vue&type=style&index=0&id=5d97c85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97c85e",
  null
  
)

export default component.exports